module.exports = __webpack_public_path__ + "media/images/icon__clear-843bed8c34ca57a9f1aa66d4c69feee5.png";